import * as s from './styles';
import * as tp from './types';

export const SimpleSelect = ({
  options,
  value,
  onChange,
  className,
  placeholder,
  valueKey,
  labelKey,
  disabled,
  label,
}: tp.SelectProps) => (
  <s.SimpleSelectContainer disabled={disabled}>
    {label && <s.Label>{label}</s.Label>}

    <select
      className={`select ${className}`}
      onChange={(e: any) => onChange(e)}
      value={value}
      placeholder={placeholder ?? 'Select'}
      disabled={disabled}
      style={{ maxHeight: '30px' }}
    >
      <option value="" disabled>
        {placeholder}
      </option>
      {options.map((option: any) => (
        <option key={option.value} value={valueKey ? option[valueKey] : option.value}>
          {labelKey ? option[labelKey] : option.label}
        </option>
      ))}
    </select>
  </s.SimpleSelectContainer>
);

export default SimpleSelect;
